'use client';

import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { useIsMobile } from '@/hooks/use-mobile';

export function ResponsiveDrawer(
  props: React.ComponentProps<typeof DrawerPrimitive.Root>,
) {
  const isMobile = useIsMobile();
  return (
    <DrawerPrimitive.Root
      data-slot="drawer"
      direction={props.direction ?? (isMobile ? 'bottom' : 'right')}
      {...props}
    />
  );
}
